import React from "react";
import {
    LineChart,
    BarChart,
    AreaChart,
    PieChart,
} from "../../../../components/Charts";
import { CardContainer } from "../../../../components/Card";
import { formatCurrency } from "../utils/StatUtils";

const TOOL_USAGE_SERIES = [
    { key: "daily_used", name: "Daily Tool" },
    { key: "linkit_used", name: "Linkit" },
    { key: "score_used", name: "Score" },
    { key: "qr_used", name: "QR Code" },
];

export const renderChartByMetric = (data = [], filterBy, selectedMetric) => {
    if (!Array.isArray(data)) return null;
    const safeData = data.map((item = {}) => ({ ...item }));

    const safeSeries = (series) =>
        series.map(({ name, key }) => ({ name, key }));

    const renderCardSet = (charts) => <CardContainer>{charts}</CardContainer>;

    const renderCharts = (
        lineSeries,
        barSeries,
        areaSeries,
        titlePrefix = ""
    ) => (
        <>
            {renderCardSet(
                <LineChart
                    data={safeData}
                    series={safeSeries(lineSeries)}
                    xKey="week"
                    title={`${titlePrefix}Line Chart`}
                    yFormatter={
                        lineSeries.some((s) => s.key.includes("paid"))
                            ? formatCurrency
                            : undefined
                    }
                />
            )}

            {renderCardSet([
                <BarChart
                    key="bar"
                    data={safeData}
                    series={safeSeries(barSeries)}
                    xKey="week"
                    title={`${titlePrefix}Bar Chart`}
                    yFormatter={
                        barSeries.some((s) => s.key.includes("paid"))
                            ? formatCurrency
                            : undefined
                    }
                />,
                <PieChart
                    key="pie"
                    data={safeData}
                    series={TOOL_USAGE_SERIES}
                    title="Tool Usage Distribution"
                />,
            ])}

            {renderCardSet(
                <AreaChart
                    data={safeData}
                    series={safeSeries(areaSeries)}
                    xKey="week"
                    title={`${titlePrefix}Area Chart`}
                    yFormatter={
                        areaSeries.some((s) => s.key.includes("paid"))
                            ? formatCurrency
                            : undefined
                    }
                />
            )}
        </>
    );

    switch (selectedMetric) {
        case "financial":
            return renderCharts(
                filterBy === "weeklyView"
                    ? [
                          { name: "Collabs Billed", key: "collabs_billed" },
                          { name: "Affiliate Billed", key: "affiliate_billed" },
                          { name: "Scaled Billed", key: "scaled_billed" },
                      ]
                    : [
                          {
                              name: "Collabs Billed (cumulative)",
                              key: "collabs_billed_Cumulative",
                          },
                          {
                              name: "Affiliate Billed (cumulative)",
                              key: "affiliate_billed_Cumulative",
                          },
                          {
                              name: "Scaled Billed (cumulative)",
                              key: "scaled_billed_Cumulative",
                          },
                      ],
                filterBy === "weeklyView"
                    ? [{ name: "Collabs Billed", key: "collabs_billed" }]
                    : [
                          {
                              name: "Collabs Billed (cumulative)",
                              key: "collabs_billed_Cumulative",
                          },
                      ],
                filterBy === "weeklyView"
                    ? [{ name: "Collabs Billed", key: "collabs_billed" }]
                    : [
                          {
                              name: "Collabs Billed (cumulative)",
                              key: "collabs_billed_Cumulative",
                          },
                      ],
                "Financial Revenue "
            );

        case "creatorGrowth":
            return renderCharts(
                filterBy === "weeklyView"
                    ? [
                          {
                              name: "Total Signed Creators",
                              key: "total_signed_creators",
                          },
                          { name: "Total Affiliates", key: "total_affiliates" },
                          {
                              name: "Total Creator Pros",
                              key: "total_creator_pros",
                          },
                          {
                              name: "Total Active Creators",
                              key: "total_active_creators",
                          },
                      ]
                    : [
                          {
                              name: "Total Signed Creators (Cumulative)",
                              key: "total_signed_creators_Cumulative",
                          },
                          {
                              name: "Total Affiliates (Cumulative)",
                              key: "total_affiliates_Cumulative",
                          },
                          {
                              name: "Total Creator Pros (Cumulative)",
                              key: "total_creator_pros_Cumulative",
                          },
                          {
                              name: "Total Active Creators (Cumulative)",
                              key: "total_active_creators_Cumulative",
                          },
                      ],
                filterBy === "weeklyView"
                    ? [
                          {
                              name: "Total Signed Creators",
                              key: "total_signed_creators",
                          },
                      ]
                    : [
                          {
                              name: "Total Signed Creators (Cumulative)",
                              key: "total_signed_creators_Cumulative",
                          },
                      ],
                filterBy === "weeklyView"
                    ? [
                          {
                              name: "Total Signed Creators",
                              key: "total_signed_creators",
                          },
                      ]
                    : [
                          {
                              name: "Total Signed Creators (Cumulative)",
                              key: "total_signed_creators_Cumulative",
                          },
                      ],
                "Creator Growth "
            );

        case "engagement":
            return renderCharts(
                filterBy === "weeklyView"
                    ? [
                          { name: "Stores Viewed", key: "stores_viewed" },
                          { name: "Stores Created", key: "stores_created" },
                          { name: "Collabs Viewed", key: "collabs_viewed" },
                          { name: "Collabs Engaged", key: "collabs_engaged" },
                      ]
                    : [
                          {
                              name: "Stores Viewed (Cumulative)",
                              key: "stores_viewed_Cumulative",
                          },
                          {
                              name: "Stores Created (Cumulative)",
                              key: "stores_created_Cumulative",
                          },
                          {
                              name: "Collabs Viewed (Cumulative)",
                              key: "collabs_viewed_Cumulative",
                          },
                          {
                              name: "Collabs Engaged (Cumulative)",
                              key: "collabs_engaged_Cumulative",
                          },
                      ],
                filterBy === "weeklyView"
                    ? [{ name: "Stores Viewed", key: "stores_viewed" }]
                    : [
                          {
                              name: "Stores Viewed (Cumulative)",
                              key: "stores_viewed_Cumulative",
                          },
                      ],
                filterBy === "weeklyView"
                    ? [{ name: "Stores Viewed", key: "stores_viewed" }]
                    : [
                          {
                              name: "Stores Viewed (Cumulative)",
                              key: "stores_viewed_Cumulative",
                          },
                      ],
                "Engagement "
            );

        case "toolUsage":
            return renderCharts(
                filterBy === "weeklyView"
                    ? [
                          { key: "daily_visits", name: "Daily Tool" },
                          { key: "linkit_visits", name: "Linkit" },
                          { key: "score_visits", name: "Score" },
                          { key: "qr_visits", name: "QR Code" },
                      ]
                    : [
                          {
                              name: "Daily Visits (Cumulative)",
                              key: "daily_visits_Cumulative",
                          },
                          {
                              name: "Linkit Visits (Cumulative)",
                              key: "linkit_visits_Cumulative",
                          },
                          {
                              name: "QR Visits (Cumulative)",
                              key: "qr_visits_Cumulative",
                          },
                          {
                              name: "Score Visits (Cumulative)",
                              key: "score_visits_Cumulative",
                          },
                      ],
                filterBy === "weeklyView"
                    ? [{ name: "Daily Visits", key: "daily_visits" }]
                    : [
                          {
                              name: "Daily Visits (Cumulative)",
                              key: "daily_visits_Cumulative",
                          },
                      ],
                filterBy === "weeklyView"
                    ? [{ name: "Daily Visits", key: "daily_visits" }]
                    : [
                          {
                              name: "Daily Visits (Cumulative)",
                              key: "daily_visits_Cumulative",
                          },
                      ],
                "Tool Usage "
            );

        case "conversions":
            return renderCharts(
                filterBy === "weeklyView"
                    ? [
                          {
                              name: "Store Conversion %",
                              key: "store_conversion",
                          },
                          {
                              name: "Collab Conversion %",
                              key: "collab_conversion",
                          },
                          {
                              name: "Daily Conversion %",
                              key: "daily_conversion",
                          },
                          {
                              name: "Linkit Conversion %",
                              key: "linkit_conversion",
                          },
                      ]
                    : [
                          {
                              name: "Store Conversion % (Cumulative)",
                              key: "store_conversion_Cumulative",
                          },
                          {
                              name: "Collab Conversion % (Cumulative)",
                              key: "collab_conversion_Cumulative",
                          },
                          {
                              name: "Daily Conversion % (Cumulative)",
                              key: "daily_conversion_Cumulative",
                          },
                          {
                              name: "Linkit Conversion % (Cumulative)",
                              key: "linkit_conversion_Cumulative",
                          },
                      ],
                filterBy === "weeklyView"
                    ? [{ name: "Store Conversion %", key: "store_conversion" }]
                    : [
                          {
                              name: "Store Conversion (Cumulative)",
                              key: "store_conversion_Cumulative",
                          },
                      ],
                filterBy === "weeklyView"
                    ? [{ name: "Store Conversion %", key: "store_conversion" }]
                    : [
                          {
                              name: "Store Conversion (Cumulative)",
                              key: "store_conversion_Cumulative",
                          },
                      ],
                "Conversion Rates "
            );

        case "payments":
            return renderCharts(
                filterBy === "weeklyView"
                    ? [
                          { name: "Total Auto Paid", key: "total_auto_paid" },
                          {
                              name: "Total Manual Paid",
                              key: "total_manual_paid",
                          },
                      ]
                    : [
                          {
                              name: "Total Auto Paid (Cumulative)",
                              key: "total_auto_paid_Cumulative",
                          },
                          {
                              name: "Total Manual Paid (Cumulative)",
                              key: "total_manual_paid_Cumulative",
                          },
                      ],
                filterBy === "weeklyView"
                    ? [{ name: "Total Auto Paid", key: "total_auto_paid" }]
                    : [
                          {
                              name: "Total Auto Paid (Cumulative)",
                              key: "total_auto_paid_Cumulative",
                          },
                      ],
                filterBy === "weeklyView"
                    ? [{ name: "Total Auto Paid", key: "total_auto_paid" }]
                    : [
                          {
                              name: "Total Auto Paid (Cumulative)",
                              key: "total_auto_paid_Cumulative",
                          },
                      ],
                "Payment Analytics "
            );

        case "targetAchievements":
            return renderCharts(
                filterBy === "weeklyView"
                    ? [
                          { name: "Collabs Target", key: "collabs_target" },
                          { name: "Scaled Target", key: "scaled_target" },
                          { name: "Affiliate Target", key: "affiliate_target" },
                      ]
                    : [
                          {
                              name: "Collabs Target (Cumulative)",
                              key: "collabs_target_Cumulative",
                          },
                          {
                              name: "Scaled Target (Cumulative)",
                              key: "scaled_target_Cumulative",
                          },
                          {
                              name: "Affiliate Target (Cumulative)",
                              key: "affiliate_target_Cumulative",
                          },
                      ],
                filterBy === "weeklyView"
                    ? [{ name: "Collabs Target", key: "collabs_target" }]
                    : [
                          {
                              name: "Collabs Target (Cumulative)",
                              key: "collabs_target_Cumulative",
                          },
                      ],
                filterBy === "weeklyView"
                    ? [{ name: "Collabs Target", key: "collabs_target" }]
                    : [
                          {
                              name: "Collabs Target (Cumulative)",
                              key: "collabs_target_Cumulative",
                          },
                      ],
                "Target Achievement "
            );

        default:
            return null;
    }
};
